// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3239":"31d6cfe0","4317":"e2011418"}[chunkId] + ".chunk.css";
};